import axios from './axios';

export const getConstraintTypes = () =>
    axios.get('/constraints/types').then(res => res.data);

export const checkTeamCompliance = (constraints) =>
    axios.post('/constraints/check-compliance', { constraints }).then(res => res.data);

export const validateTeam = (userTeamID, constraints) =>
    axios.post('/constraints/validate-team', { userTeamID, constraints }).then(res => res.data);

export const getEligibleCards = (constraints) =>
    axios.post('/constraints/eligible-cards', { constraints }).then(res => res.data);
